import { z } from '@hono/zod-openapi'

// id
export const idZ = z.string().openapi({
  description: '組織ID',
  example: '00000000-0000-4000-8000-000000000100',
})
export type id = z.infer<typeof idZ>

// name
export const nameZ = z
  .string()
  .min(1)
  .max(255)
  .openapi({ description: '組織名', example: '関西支社' })
export type name = z.infer<typeof nameZ>

// slug
// slug は組織の一意キーとして URL やコマンドに現れるため記号を許さない。
export const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]*$/

export const slugZ = z
  .string()
  .min(1)
  .max(255)
  .regex(
    SLUG_PATTERN,
    'スラッグは英小文字または数字で始まり、英小文字・数字・ハイフンのみ使用できます',
  )
  .openapi({ description: '組織を識別する一意な値', example: 'kansai' })
export type slug = z.infer<typeof slugZ>

// logo
export const logoZ = z
  .string()
  .nullable()
  .openapi({ description: '組織ロゴ', example: null })
export type logo = z.infer<typeof logoZ>

// metadata
export const metadataZ = z
  .string()
  .nullable()
  .openapi({ description: '組織のメタデータ', example: null })
export type metadata = z.infer<typeof metadataZ>

// memberCount
export const memberCountZ = z
  .number()
  .openapi({ description: '組織に所属する管理者数', example: 3 })
export type memberCount = z.infer<typeof memberCountZ>

// roleCount
export const roleCountZ = z
  .number()
  .openapi({ description: '組織に定義されたロール数', example: 5 })
export type roleCount = z.infer<typeof roleCountZ>

// createdAt
export const createdAtStringZ = z
  .string()
  .openapi({ description: '作成日時', example: '2024-01-01T00:00:00.000Z' })
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>
